import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=8a968bbc&scoped=true"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=8a968bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a968bbc",
  null
  
)

export default component.exports